import React from "react";
import MainWhiteContainer from "components/Buttons/MainWhiteContainer";
import { Grid, Dimmer, Loader, Confirm, Message } from "semantic-ui-react";
import TubeCard from "features/FolderManager/components/Tubes/TubeCard";
import TubeDetailsModal from "features/FolderManager/components/modals/TubeDetailsModal";
import NotesForTubeDetailedModal from "features/FolderManager/components/modals/NotesForTubeDetailedModal";
import { toast } from "react-toastify";
import BlueButtonEditBloc from "components/Buttons/BlueButtonEditBloc";
import AddTubeModal from "../modals/AddTubeModal";
import AnalysisDetailsModal from "features/FolderManager/components/Prescription/AnalysisDetailsModal";
import isEqual from "lodash.isequal";
import ReuseTubeModal from "../modals/ReuseTubeModal";
import TubeNatureModal from "../modals/TubeNatureModal";
import TubeUntakenModal from "../modals/TubeUntakenModal";
import { errorHandler, ErrorAction } from "utils/error";
import { getWaitingTime } from "utils/dateUtils";
import moment from "moment";
import { getTimeBetweenInSec } from "utils/dateUtils";
export default class Tubes extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			barcodeReaderOpen: false,
			tubeLinks: null,
			tube: null,
			tubeDetailsModal: false,
			tubeDetailed: null,
			addTubeModal: false,
			analysisDetailsModal: false,
			analysisDetailed: null,
			reuseTubeModalOpen: false,
			confirmCancelReuseTubeOpen: false,
			barcode: null,
			natureTubeModalSelectedValue: null,
			untakenTubeModal: false,
			confirmDeleteNotPrescribedTube: false,
			firstSamplingTime: null,
			affectTube: true,
			notesDetailsModal: false,
			notesForTubeDetailed: null,
		};
	}

	componentDidMount = () => {
		this.props.getAllTubeNatureReasons();
		this.openFirstTube();
		this.getFirstSamplingTime();
	};

	componentDidUpdate() {
		if (!this.state.firstSamplingTime) this.getFirstSamplingTime();
	}

	toggleTube = (tube) => {
		// Attention ici un tube peut être relié à plusieurs tubes (même tubeLibrary)
		this.props.toggleTube(tube);
	};

	submitAddTubeModal = (values) => {
		this.props.submitAddTubeModal(values).then(() => {
			if (this.props.folder && this.props.folder.length > 0) this.props.getMissingVolumeTubes(this.props.folder[0].id);
		});
	};

	closeBarcodeReader = (reset) => {
		if (reset) {
			this.setState({
				hasCameraAccess: false,
				barcodeReaderOpen: false,
				tubeLinks: null,
				tube: null,
			});
		} else {
			this.setState({
				barcodeReaderOpen: false,
			});
		}
	};

	select = (tube) => {
		const scanAvailableState = {
			hasCameraAccess: true,
			barcodeReaderOpen: true,
			tubeLinks: tube.links,
			tube: tube,
		};
		this.setState(scanAvailableState);
	};

	deselect = () => {
		const scanAvailableState = {
			hasCameraAccess: false,
			barcodeReaderOpen: false,
			tubeLinks: null,
			tube: null,
		};
		this.setState(scanAvailableState);
	};

	openBarcodeReader = (tube) => {
		const scanAvailableState = {
			hasCameraAccess: true,
			barcodeReaderOpen: true,
			tubeLinks: tube.links,
			tube: tube,
		};

		if (tube && tube.provider_barcode && tube.provider_barcode !== "" && (!this.state.tube || tube.properties_id !== this.state.tube.properties_id)) {
			this.setState({
				tubeWarningOpen: true,
			});
		}
		this.setState(scanAvailableState);
	};

	affectTube = () => {
		this.setState({ affectTube: true });
	};

	getTubeNatureFromCode = (tube) => {
		return tube?.properties?.code;
	};

	checkMultipleTubeSameNature = (tube) => {
		const { tubes } = this.props;
		return tubes.filter((t) => this.getTubeNatureFromCode(t) === this.getTubeNatureFromCode(tube)).length > 1;
	};

	submitBarcodeReader = (values) => {
		if (this.state.tube) {
			const multipleTubeSameNature = this.checkMultipleTubeSameNature(this.state.tube);
			if (multipleTubeSameNature) {
				this.setState({ barcode: values });
				this.openNatureTubeModal();
			} else this.patchTube(values);
		}
	};

	getFirstSamplingTime = () => {
		const { tubes } = this.props;
		if (tubes) {
			var result = tubes.filter((t) => t.sampling_time).sort((a, b) => moment(a.sampling_time) - moment(b.sampling_time));
			if (result && result[0] && result[0].sampling_time) this.setState({ firstSamplingTime: result[0].sampling_time });
		}
	};

	sortTubes = (a, b) => {
		if (a.properties.taking_order - b.properties.taking_order === 0) return a.properties.timer - b.properties.timer;
		else return a.properties.taking_order - b.properties.taking_order;
	};

	patchTube = (barcode, natureReason) => {
		const links = this.state.tubeLinks;
		if (this.state.tube.provider_barcode !== barcode)
			this.props.patchMultipleTubes(links, barcode, true, natureReason).then((res) => {
				this.setState({ tubeLinks: null, tube: null });
				if (res.success) {
					const orderedTubes = this.props.tubes
						.filter((t) => (this.props.aliquot && t.properties.aliquot) || (!this.props.aliquot && !t.properties.aliquot))
						.sort(this.sortTubes);

					const index = orderedTubes.findIndex((tube) => {
						return tube.links.includes(links[0]);
					});

					if (index >= 0 && index < orderedTubes.length - 1) {
						// Check each until end of array, barcode null and reason null
						for (let nextTubeIndex = index + 1; nextTubeIndex < orderedTubes.length; nextTubeIndex++) {
							if (
								orderedTubes[nextTubeIndex]?.provider_barcode === null &&
								orderedTubes[nextTubeIndex]?.untaken_reason === null &&
								orderedTubes[nextTubeIndex]?.properties.take_number_before_display <= this.props.take_number
							) {
								this.openBarcodeReader(orderedTubes[nextTubeIndex]);
								return;
							}
						}
					}
				}
			});
		else {
			this.setState({ tubeLinks: null, tube: null });
			const orderedTubes = this.props.tubes
				.filter((t) => (this.props.aliquot && t.properties.aliquot) || (!this.props.aliquot && !t.properties.aliquot))
				.sort(this.sortTubes);

			const index = orderedTubes.findIndex((tube) => {
				return tube.links.includes(links[0]);
			});

			if (index >= 0 && index < orderedTubes.length - 1) {
				// Check each until end of array, barcode null and reason null
				for (let nextTubeIndex = index + 1; nextTubeIndex < orderedTubes.length; nextTubeIndex++) {
					if (
						orderedTubes[nextTubeIndex]?.provider_barcode === null &&
						orderedTubes[nextTubeIndex]?.untaken_reason === null &&
						orderedTubes[nextTubeIndex]?.properties.take_number_before_display <= this.props.take_number
					) {
						this.openBarcodeReader(orderedTubes[nextTubeIndex]);
						return;
					}
				}
			}
		}
	};

	openFirstTube = () => {
		const orderedTubes = this.props.tubes
			.filter((t) => (this.props.aliquot && t.properties.aliquot) || (!this.props.aliquot && !t.properties.aliquot))
			.sort(this.sortTubes);
		for (let tubeIndex = 0; tubeIndex < orderedTubes.length; tubeIndex++) {
			if (
				orderedTubes[tubeIndex]?.provider_barcode === null &&
				orderedTubes[tubeIndex]?.untaken_reason === null &&
				orderedTubes[tubeIndex]?.properties.take_number_before_display <= this.props.take_number
			) {
				this.openBarcodeReader(orderedTubes[tubeIndex]);
				return;
			}
		}
	};

	patchTubeSamplingTime = (tube, sampling_time) => {
		this.props.patchTubeSamplingTime(tube, sampling_time);
	};

	openTubeDetailsModal = (tube) => {
		this.setState({ tubeDetailsModal: true, tubeDetailed: tube });
	};

	closeTubeDetailsModal = () => {
		this.setState({ tubeDetailsModal: false, tubeDetailed: null });
	};

	openNotesDetailsModal = (tube) => {
		this.setState({ notesDetailsModal: true, notesForTubeDetailed: tube });
	};

	closeNotesDetailsModal = () => {
		this.setState({ notesDetailsModal: false, notesForTubeDetailed: null });
	};

	openAddTubeModal = () => {
		this.closeBarcodeReader(true);
		this.props.loadAddTubeModalData();
		this.setState({ addTubeModal: true });
	};

	closeAddTubeModal = () => {
		this.setState({ addTubeModal: false });
	};

	openAnalysisDetailsModal = (analysis) => {
		this.setState({ analysisDetailsModal: true, analysisDetailed: analysis });
	};

	closeAnalysisDetailsModal = () => {
		this.setState({ analysisDetailsModal: false, analysisDetailed: null });
	};

	openReuseTubeModal = (tube) => {
		this.closeBarcodeReader(true);
		this.props.getReusableTubes();
		this.setState({
			reuseTubeModalOpen: true,
			tubeLinks: tube.links,
			tube: tube,
		});
	};

	closeReuseTubeModal = () => {
		this.setState({
			reuseTubeModalOpen: false,
			tubeLinks: null,
			tube: null,
		});
	};

	submitReuseTubeModal = (originalBarcode) => {
		const links = this.state.tubeLinks;
		this.props.patchMultipleTubes(links, originalBarcode, false).then(() => {
			this.setState({ tubeLinks: null, tube: null });
		});
	};

	openConfirmCancelReuseTube = (tube) => {
		this.setState({
			confirmCancelReuseTubeOpen: true,
			tubeLinks: tube.links,
			tube: tube,
		});
	};

	closeConfirmCancelReuseTube = () => {
		this.setState({
			confirmCancelReuseTubeOpen: false,
			tubeLinks: null,
			tube: null,
		});
	};

	submitConfirmCancelReuseTube = () => {
		const links = this.state.tubeLinks;
		this.props.cancelReuseTube(links).then(() => {
			this.closeConfirmCancelReuseTube();
		});
	};

	openNatureTubeModal = async (tube) => {
		this.closeBarcodeReader(tube ? true : false);
		await this.props.getAllTubeNatureReasons();
		if (tube)
			this.setState({
				tubeLinks: tube.links,
				tube: tube,
				natureTubeModalSelectedValue: tube.nature_reason,
			});
		this.setState({ natureTubeModal: true });
	};

	closeNatureTubeModal = () => {
		this.setState({
			tubeLinks: null,
			tube: null,
			barcode: null,
			natureTubeModal: false,
			natureTubeModalSelectedValue: null,
		});
	};

	submitNatureTubeModal = async (values) => {
		const { barcode } = this.state;
		//If a barcode exists, we are scanning a tube
		if (barcode) this.patchTube(barcode, values.nature_reason);
		//Otherwise, we just update an existing one
		else {
			const { tubeLinks } = this.state;
			this.props
				.patchTubeNature(tubeLinks, values.nature_reason)
				.then((res) => {
					if (!res.success) {
						toast.error("Modification du commentaire impossible, une erreur s'est produite lors de la sauvegarde dans la base de données.");
					}
				})
				.catch((err) => errorHandler("Commentaire nature tube", ErrorAction.UPDATE, err));
		}
		this.closeNatureTubeModal();
	};

	onUntakenTube = async (tube) => {
		this.closeBarcodeReader(true);
		await this.setState({
			tube: tube,
			tubeLinks: tube.links,
		});
		if (tube.status === "UNTAKEN") {
			this.submitUntakenTubeModal(null);
		} else {
			await this.props.getAllTubeUntakenReasons();
			this.setState({
				untakenTubeModal: true,
			});
		}
	};

	closeUntakenTubeModal = () => {
		this.setState({ untakenTubeModal: false, tube: null, tubeLinks: null });
	};

	submitUntakenTubeModal = async (untaken_reason) => {
		const { tubeLinks } = this.state;
		this.props
			.patchUntakenTube(tubeLinks, untaken_reason)
			.then((res) => {
				if (!res.success)
					toast.error("Modification du commentaire impossible, une erreur s'est produite lors de la sauvegarde dans la base de données.");
			})
			.catch((err) => errorHandler("Commentaire tube non prélevé", ErrorAction.UPDATE, err));

		this.closeUntakenTubeModal();
	};

	openDeleteNotPrescribedTubeConfirm = (tube) => {
		this.closeBarcodeReader(true);
		this.setState({
			confirmDeleteNotPrescribedTube: true,
			tube: tube,
			tubeLinks: tube.links,
		});
	};

	closeDeleteNotPrescribedTubeConfirm = () => {
		this.setState({
			confirmDeleteNotPrescribedTube: false,
			tube: null,
			tubeLinks: null,
		});
	};

	//Function created just for covid in order to show a blue background when covid is linked to GRIPPE/RSV
	//Remove when covid is done
	covidBackgroundColor = (tube) => {
		const covidAnalyses = process.env.REACT_APP_ANALYSES_COVID.split(" ");
		const isCovid = tube?.analyses?.findIndex((ana) => covidAnalyses.includes(ana.properties.catalog_code));
		if (isCovid > -1) {
			const linkedAnalyses = process.env.REACT_APP_ANALYSES_TUBE_COLOR.split(" ");
			if (tube.analyses.findIndex((ana) => linkedAnalyses.includes(ana.properties.catalog_code)) > -1) return "rgba(36, 113, 163,0.33)";
		}
		return null;
	};

	canScan = () => {
		let { tubes } = this.props;
		const { tube } = this.state;
		if (!tube) return false;
		var firstSamplingTime = null;
		var sampled = tubes
			.filter((t) => (this.props.aliquot && t.properties.aliquot) || (!this.props.aliquot && !t.properties.aliquot))
			.filter((t) => t.sampling_time)
			.sort((t) => t.sampling_time);
		if (sampled && sampled[0] && sampled[0].sampling_time) firstSamplingTime = sampled[0].sampling_time;
		if (!tube.properties) return false;
		return firstSamplingTime
			? getWaitingTime(moment().toDate(), moment(firstSamplingTime).add(tube.properties.timer, "m")) === "" ||
					getWaitingTime(moment().toDate(), moment(firstSamplingTime).add(tube.properties.timer, "m")) === "maintenant"
			: tube.properties.timer === 0;
	};

	regexForTube = (tube) => {
		if (tube.properties?.regex) {
			return new RegExp(tube.properties?.regex);
		}
		if (tube.properties?.sil_code.includes("NPAG")) return new RegExp("^([0-9]{8}|[a-zA-Z][0-9]-[0-9]{2})$");
		return new RegExp(process.env.REACT_APP_BARCODE_REGEX.concat("$"));
	};

	getPrimaryForAliquot = (tube) => {
		if (tube && tube.properties && tube.properties.primary) {
			return this.props.tubes.find((t) => t.properties && t.properties.code === tube.properties.primary.code);
		}
		return null;
	};

	getAnalysisWaitingTimeBeforeSampling = () => {
		if (this.props.folder && this.props.folder.length > 0) {
			var max = this.getMaxWaitingTimeBeforeSampling();
			if (this.props.folder.labAppointment)
				return getTimeBetweenInSec(moment(this.props.folder.labAppointment._date + " " + this.props.folder.labAppointment._time).add(max, "m"));
			else return getTimeBetweenInSec(moment(this.props.folder[0].created_at).add(max, "m"));
		}
		return 0;
	};
	getMaxWaitingTimeBeforeSampling = () => {
		return Math.max(...this.props.tubes.flatMap((t) => t.analyses?.map((a) => a.properties.waiting_time_before_sampling)));
	};

	render() {
		let { tubes, disabled, tubeReducer, isHome, safeplaceResult, urgencyPretreatementLimit, aliquot, isDeposit } = this.props;
		tubes = tubes.filter((t) => (this.props.aliquot && t.properties.aliquot) || (!this.props.aliquot && !t.properties.aliquot));

		if (tubes.length === 0) return <div>Il n'y a aucun tube pour ce dossier.</div>;
		return (
			<div>
				{tubeReducer.reusable.loading && tubeReducer.missingVolume.loading && (
					<Dimmer active>
						<Loader />
					</Dimmer>
				)}
				{this.props.tubes.filter((t) => t.analyses && t.analyses.filter((a) => a.properties.waiting_time_before_sampling > 0).length > 0).length >
					0 &&
					this.getAnalysisWaitingTimeBeforeSampling() > 0 && (
						<Message
							warning
							header={`Certaines analyses requièrent un temps d'attente avant le prélèvement (${this.getMaxWaitingTimeBeforeSampling()} min)`}
							content={
								<div>
									<div>
										Dossier créé à{" "}
										{this.props.folder[0].labAppointment
											? this.props.folder[0].labAppointment._time.substring(this.props.folder[0].labAppointment._time.length - 3, 0)
											: moment(this.props.folder[0].created_at).format("HH:mm")}{" "}
									</div>
									<div>{`Temps d'attente restant : ${(this.getAnalysisWaitingTimeBeforeSampling() / 60).toFixed(0)} minutes`}</div>
								</div>
							}
						></Message>
					)}

				{/* <div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					{this.state.barcodeReaderOpen && this.canScan() && !disabled && (
						<ScanContainer
							close={this.closeBarcodeReader}
							submit={this.submitBarcodeReader}
							regex={this.regexForTube(tube)}
							cardBackgroundColor={this.covidBackgroundColor(tube) ?? "white"}
							cardContent={
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexWrap: "wrap",
										cursor: "pointer",
										position: "relative",
									}}
								>
									<Image
										floated="left"
										size="tiny"
										src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
											tube.properties.picto !== null ? tube.properties.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME
										}`}
										style={{ marginRight: 0 }}
									/>
									<Card.Header style={{ width: "100%", textAlign: "center" }}>{tube.properties.label}</Card.Header>
									{tube.added_reason !== null && <Card.Description>Ajout : {tube.added_reason}</Card.Description>}
									{tube.nature_reason && <Card.Description>Nature : {tube.nature_reason}</Card.Description>}
								</div>
							}
						/>
					)}
				</div> */}

				<MainWhiteContainer>
					<Grid style={{ margin: 0, width: "100%" }}>
						{tubeReducer.missingVolume.list.length > 0 && (
							<Grid.Row>
								<Grid.Column mobile={16} tablet={16} computer={16}>
									<Message
										warning
										header="Volume insuffisant pour certains tubes"
										content="Les tubes ci-dessus ont un volume insuffisant et toutes les analyses ne pourront pas être réalisées. Vous pouvez ajouter un tube pour remédier à ce problème."
										list={tubeReducer.missingVolume.list.map((tube) => `${tube.code} - ${tube.label}`)}
									/>
								</Grid.Column>
							</Grid.Row>
						)}
						{!disabled && isDeposit && (
							<Grid.Row>
								<Grid.Column
									mobile={16}
									tablet={16}
									computer={16}
									style={{
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									{/* <BlueButtonEditBloc
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.openAddTubeModal();
										}}
										text="Ajouter un tube"
										disabled={disabled}
									/> */}
								</Grid.Column>
							</Grid.Row>
						)}
						<Grid.Row>
							{tubes.sort(this.sortTubes).map((tube, key) => {
								return (
									<Grid.Column key={"tubeColumn" + key} mobile={16} tablet={5} computer={4}>
										<TubeCard
											tube={tube}
											openTubeDetails={this.openTubeDetailsModal}
											onUntaken={this.onUntakenTube}
											openDeleteNotPrescribedTubeConfirm={this.openDeleteNotPrescribedTubeConfirm}
											take_number={this.props.take_number}
											openBarcode={this.openBarcodeReader}
											patchTubeSamplingTime={this.patchTubeSamplingTime}
											key={"tube" + key}
											disabled={disabled}
											isSelected={isEqual(tube.links, this.state.tubeLinks)}
											canReuseTube={tubeReducer.reusable.list.filter((t) => t.properties_id === tube.properties_id).length > 0}
											openReuseTubeModal={this.openReuseTubeModal}
											openConfirmCancelReuseTube={this.openConfirmCancelReuseTube}
											openNatureTubeModal={this.openNatureTubeModal}
											isHome={isHome}
											covidBackgroundColor={this.covidBackgroundColor}
											waitingFirstSampling={tube.properties.timer && this.state.firstSamplingTime === null ? tube.properties.timer : 0}
											timer={
												!tube.sampling_time && tube.properties.timer && this.state.firstSamplingTime !== null
													? getWaitingTime(moment().toDate(), moment(this.state.firstSamplingTime).add(tube.properties.timer, "m").toDate())
													: ""
											}
											safeplaceResult={safeplaceResult}
											urgencyPretreatementLimit={urgencyPretreatementLimit}
											aliquot={aliquot}
											aliquotPrimary={this.getPrimaryForAliquot(tube)}
											submitBarCode={this.submitBarcodeReader}
											regex={this.regexForTube(tube)}
											cancelSelect={() => this.closeBarcodeReader(true)}
											selectTube={this.select}
											openNotesDetails={this.openNotesDetailsModal}
										/>
									</Grid.Column>
								);
							})}
						</Grid.Row>
					</Grid>

					<TubeDetailsModal
						open={this.state.tubeDetailsModal}
						close={this.closeTubeDetailsModal}
						tube={this.state.tubeDetailed}
						urgencyPretreatementLimit={urgencyPretreatementLimit}
					/>
					<NotesForTubeDetailedModal open={this.state.notesDetailsModal} close={this.closeNotesDetailsModal} tube={this.state.notesForTubeDetailed} />

					<AddTubeModal open={this.state.addTubeModal} close={this.closeAddTubeModal} submit={this.submitAddTubeModal} tubes={tubes} />
					<AnalysisDetailsModal
						open={this.state.analysisDetailsModal}
						close={this.closeAnalysisDetailsModal}
						analysis={this.state.analysisDetailed}
						isHome={isHome}
					/>

					<ReuseTubeModal
						reusableTubes={tubeReducer.reusable.list.filter((t) => t.properties_id === this.state.tube?.properties_id)}
						open={this.state.reuseTubeModalOpen}
						close={this.closeReuseTubeModal}
						submit={this.submitReuseTubeModal}
					/>

					<TubeNatureModal
						open={this.state.natureTubeModal}
						close={this.closeNatureTubeModal}
						submit={this.submitNatureTubeModal}
						selectedValue={this.state.natureTubeModalSelectedValue}
					/>

					<TubeUntakenModal open={this.state.untakenTubeModal} close={this.closeUntakenTubeModal} submit={this.submitUntakenTubeModal} />

					<Confirm
						open={this.state.confirmCancelReuseTubeOpen}
						content="Êtes-vous sûr de vouloir annuler la réutilisation du tube ?"
						cancelButton="Non"
						confirmButton="Oui"
						onCancel={this.closeConfirmCancelReuseTube}
						onConfirm={this.submitConfirmCancelReuseTube}
					/>

					<Confirm
						open={this.state.confirmDeleteNotPrescribedTube}
						content="Êtes vous sûr de vouloir supprimer ce tube ?"
						cancelButton="Annuler"
						confirmButton="Confirmer"
						onCancel={(e) => {
							if (e !== undefined) e.preventDefault();
							this.closeDeleteNotPrescribedTubeConfirm();
						}}
						onConfirm={(e) => {
							if (e !== undefined) e.preventDefault();
							this.props.submitDeleteNotPrescribedTubeConfirm(this.state.tubeLinks).then(() => {
								this.props.getMissingVolumeTubes();
								this.closeDeleteNotPrescribedTubeConfirm();
							});
						}}
					/>
				</MainWhiteContainer>
			</div>
		);
	}
}
